// extracted by mini-css-extract-plugin
export default {"editCredentialsPopup":"CallCenterLoginPopup_editCredentialsPopup__H2O8B","textbox":"CallCenterLoginPopup_textbox__JSA6i","errorMessage":"CallCenterLoginPopup_errorMessage__iFktw"};